import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#ACB8C3" d="M37 22.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      d="M93.5 26a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M54 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M55.07 101.5H49.5v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M18.94 22.94 15 26.88l-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12L12.88 29l-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.59.58 1.54.59 2.12 0L15 31.12l3.94 3.94c.59.59 1.54.59 2.12 0s.59-1.54 0-2.12L17.12 29l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0M82 42.7V23.27c0-.7-.64-1.27-1.45-1.27h-7.11c-.79 0-1.45.56-1.45 1.27v11.71l-12.1-9.34a3.106 3.106 0 0 0-3.79 0L33 43.47V83.6c0 2.43 2.04 4.4 4.54 4.4h40.91c2.51 0 4.54-1.97 4.54-4.4V43.47l-1-.77z"
    />
    <path
      fill="#ACB8C3"
      d="M91 52c-.63 0-1.27-.2-1.81-.61l-30.4-23.12a1.29 1.29 0 0 0-1.58 0L26.82 51.39c-1.32 1-3.2.75-4.2-.57s-.75-3.2.57-4.2l30.4-23.12c2.63-2 6.18-2 8.83 0l30.41 23.13a2.997 2.997 0 0 1-1.82 5.38zM87 90H29c-1.66 0-3-1.34-3-3s1.34-3 3-3h58c1.66 0 3 1.34 3 3s-1.34 3-3 3"
    />
    <path
      fill="#F1F4FA"
      d="M46 76c-1.1 0-2-.9-2-2V50c0-1.1.9-2 2-2s2 .9 2 2v24c0 1.1-.9 2-2 2"
    />
    <path fill="#ACB8C3" d="M46 61.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9" />
    <path
      fill="#F1F4FA"
      d="M58 76c-1.1 0-2-.9-2-2V50c0-1.1.9-2 2-2s2 .9 2 2v24c0 1.1-.9 2-2 2"
    />
    <path fill="#ACB8C3" d="M58 71.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9" />
    <path
      fill="#F1F4FA"
      d="M70 76c-1.1 0-2-.9-2-2V50c0-1.1.9-2 2-2s2 .9 2 2v24c0 1.1-.9 2-2 2"
    />
    <path
      fill="#ACB8C3"
      d="M70 61.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M83 101c-9.37 0-17-7.63-17-17s7.63-17 17-17 17 7.63 17 17-7.63 17-17 17"
    />
    <path
      fill="#F1F4FA"
      d="M83 97c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13"
    />
    <path
      fill="#ACB8C3"
      d="M83 93c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9"
    />
    <path fill="#F1F4FA" d="M83 89a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />
    <path
      fill="#ACB8C3"
      d="M83 85c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2s2 .9 2 2v6c0 1.1-.9 2-2 2"
    />
  </svg>
);
const SvgEnrichedIconHomeAutomationGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconHomeAutomationGreyscale);
export default Memo;
